export enum EEtatActe {
	done = "done",
	to_be_done = "to be done",
	not_done = "not done"
}